const notFoundPageIt = {
    "not-found": {
        "title": "Pagina non trovata!",
        "description": "La pagina che stai cercando non esiste!",
        "button": "Torna alla home"
    }
}

const notFoundPageEn = {
    "not-found": {
        "title": "Page not found!",
        "description": "The page you're looking for does not exist!",
        "button": "Go back to homepage"
    }
}

export {notFoundPageIt, notFoundPageEn};